'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './community-show.routes';

export class CommunityShowComponent {
  constructor($stateParams, CommunityService, WorkOrderTicketsService, $uibModal, $window, RecentVisits, PinnedItems,
              $state, StripeService, SettingsService, CustomEntityService) {
    'ngInject';

    this.back = _ => $window.history.back();

    this.communityId = $stateParams.id;
    this.$uibModal = $uibModal;
    this.$state = $state;

    this.tasks = [];
    this.activities = [];
    this.custom = {};

    this.CommunityService = CommunityService;
    this.StripeService = StripeService;
    this.RecentVisits = RecentVisits;
    this.PinnedItems = PinnedItems;

    this.connectedBankingAccounts = [];
    this.connectedAccountsMap = {};

    this.paymentIntegrationMenu = [{
      icon: 'info',
      title: 'Show Details',
      action: _ => {
        this.openDetailModal()
      }
    },{
      icon: 'usd',
      title: 'Show Payments',
      action: _ => {
        this.openStripePaymentsModal()
      }
    }];

    SettingsService.getByName({name: 'custom-entities-views'}, settings => {
      this.customEntitiesConfig = settings.data.community || {display:[]};
      this.customEntitiesConfig.display.forEach(customType => {
        let typeConfig = this.customEntitiesConfig[customType];
        this.custom[customType] = CustomEntityService.getCustomList({type: customType, refField: typeConfig.refField, refId: $stateParams.id});

        /*this.trailerStorages = CustomEntityService.getCustomList({type: 'trailer-storage', refField: 'propertyId', refId: $stateParams.id});
        this.vehicles = CustomEntityService.getCustomList({type: 'vehicle', refField: 'propertyId', refId: $stateParams.id});
        this.pets = CustomEntityService.getCustomList({type: 'pet', refField: 'propertyId', refId: $stateParams.id});*/

      });

    });

    this.refreshData();

    WorkOrderTicketsService.getByCommunity({id: this.communityId}, data => {
      this.issues = data;
    });
  }

  createWorkOrder() {
    this.$state.go('workorder-ticket-edit',{communityId: this.communityId});
  }

  refreshData() {
    if (this.communityId) {
      this.CommunityService.get({id: this.communityId}, data => {
        this.community = data;

        if (this.community.stripe.enabled) {
          let total = this.community.stripe.connectedAccountIds.length;
          let count = 0;

          let doneFn = () => {
            this.stripeDataLoaded = true;
          };

          if (!total) {
            doneFn();
          }

          this.community.stripe.connectedAccountIds.forEach(accountId => {
            this.StripeService.getAccount({id: accountId}, account => {
              this.connectedAccountsMap[accountId] = account;
              this.connectedBankingAccounts = this.connectedBankingAccounts.concat(account.external_accounts.data.filter(act => act.object == 'bank_account'));

              count++;
              if (count == total)
                doneFn();
            }, _ => {
              count++;
              if (count == total)
                doneFn();
            });
          });
        }

        this.RecentVisits.addPortfolio(this.communityId, "community", `${this.community.code}: ${this.community.name}`);
        this.isPinned = this.PinnedItems.isPinnedPortfolio(this.communityId);

      }, err => {
        console.log('Could not load violation ticket from server');
      });
    }
  }

  openDetailModal() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'connectedAccountDetails',
      resolve: {
        config: function() {
          return {
            data: that.connectedAccount
          }
        }
      },
      size: 'md'
    });

    modalInstance.result.then(
      function () { /* ok */ },
      function () { /* cancel */ }
    );

  }

  openStripePaymentsModal() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'connectedAccountCharges',
      resolve: {
        config: function() {
          return {
            accountId: that.connectedAccount.id,
            name: that.community.name
          }
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      function () { /* ok */ },
      function () { /* cancel */ }
    );

  }

  openAssetUploadModal() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'assetUpload',
      resolve: {
        config: function() {
          return {}
        }
      }
    });

    modalInstance.result.then(resultIds => {
        that.CommunityService.addAttachments({id: that.communityId}, resultIds, _ => {
          that.refreshData();
        }, err => {
          console.log('could not add attachments to ticket');
        });
      },
      function () { /* cancel */ }
    );

  }

}

export default angular.module('conduu.communityShow', [uiRouter])
  .config(routes)
  .component('communityShow', {
    template: require('./community-show.html'),
    controller: CommunityShowComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/portfolio/community-show/community-show.component.js